import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CapabilitiesService } from '@sisoma/auth';
import { AppShell, BackToApp, Sidenav, ThemeToggle } from '@sisoma/ui';

import { environment } from '../../../environments/environment';
import { FOOTER_NAV_ITEMS, NAV_SECTIONS, filterNav, filterNavLinks } from '../navigation/nav-items';

/**
 * The admin app's composition of the shared shell: the frame and sidenav
 * behaviour come from `@sisoma/ui`, this component supplies what is specific
 * to this app — the nav registry, the brand, and the sidenav footer content.
 *
 * The nav is filtered through `CapabilitiesService` for parity with the partner
 * app. The admin surface is gated to `superAdmin` (full capability catalogue)
 * and no entry carries a `capability`, so filtering keeps everything today; the
 * computeds still re-filter reactively should gated entries ever be added.
 */
@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, AppShell, Sidenav, ThemeToggle, BackToApp],
  templateUrl: './shell.html',
  styleUrl: './shell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Shell {
  private readonly caps = inject(CapabilitiesService);

  protected readonly sections = computed(() =>
    filterNav(NAV_SECTIONS, (capability) => this.caps.has(capability)),
  );
  protected readonly footerLinks = computed(() =>
    filterNavLinks(FOOTER_NAV_ITEMS, (capability) => this.caps.has(capability)),
  );

  /** Root of the legacy `users` app for the "Back to Halio" footer link. */
  protected readonly usersAppUrl = environment.usersAppUrl;
}
